import { z } from 'zod';
import { scopeSchema, turnaroundDaysSchema } from './shared';

/** What prices a title clearance report: scope × turnaround. Everything else about the title is on the project. */
export const titleOptionsSchema = z.strictObject({
  scope: scopeSchema,
  turnaroundDays: turnaroundDaysSchema,
});
export type TitleOptions = z.infer<typeof titleOptionsSchema>;

/** A draft may still be missing the scope: the form starts with none chosen, and the customer has to pick one. */
export const titleDraftOptionsSchema = z.strictObject({
  scope: scopeSchema.nullable(),
  turnaroundDays: turnaroundDaysSchema,
});
export type TitleDraftOptions = z.infer<typeof titleDraftOptionsSchema>;
